import React, { Component } from 'react';
import { Link, withRouter, RouteComponentProps } from 'react-router-dom';
import AuthService from 'services/AuthService';
import withContext from 'context/withContext';
import LogoVoala from 'assets/images/logo/LogoVoala';
import { RoutesBase } from 'routes/constants-routes';
import { IContext, IDispatch } from 'context/reducers';

type Props = {
  context: IContext;
  refMenu: (ref: any) => void;
  cleanHome: () => void;
  refMenuToggle: (ref: any) => void;
  handleMenuToggle: () => void;
};

class HeaderMenuMobile extends Component<RouteComponentProps & Props> {
  dispatch: IDispatch;

  Auth: AuthService;

  constructor(props) {
    super(props);

    const { context } = this.props;

    this.dispatch = context.dispatch;
    this.Auth = new AuthService();

    this.logout = this.logout.bind(this);
  }

  logout() {
    this.Auth.logout();
    this.dispatch({
      type: 'LOGIN_CHANGED',
      isUserLogged: false,
    });
    const { history, location } = this.props;
    history.push(location.pathname);
  }

  render() {
    const isLogged = this.Auth.loggedIn();
    const { primeiroNome } = isLogged && this.Auth.getClient();
    const {
      refMenu,
      cleanHome,
      refMenuToggle,
      handleMenuToggle,
      location,
    } = this.props;
    /*  eslint-disable jsx-a11y/anchor-is-valid */

    return (
      <>
        <ul
          className="navbar-nav ml-md-auto text-center mobile"
          ref={ref => refMenu(ref)}
        >
          <>
            {isLogged ? (
              <>
                <li className="nav-item">
                  <Link
                    className="nav-link new-link navItemMobile"
                    to={`/${RoutesBase.myAccount.informations}`}
                  >
                    Meu Perfil
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link new-link navItemMobile"
                    to={`/${RoutesBase.myTravels.list}`}
                  >
                    Minhas Viagens
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link new-link navItemMobile"
                    to={`/${RoutesBase.recommend.home}`}
                  >
                    Voalá Recomenda
                  </Link>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link new-link navItemMobile"
                    onClick={this.logout}
                  >
                    Sair
                  </a>
                </li>
              </>
            ) : (
              <>
                <li className="nav-item">
                  <Link
                    className="nav-link new-link"
                    to={`/${RoutesBase.recommend.home}`}
                    onClick={() => cleanHome()}
                  >
                    Voalá Recomenda
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to={{
                      pathname: `/${RoutesBase.login}/acesso`,
                      state: {
                        from: location,
                      },
                    }}
                    onClick={() => cleanHome()}
                  >
                    Entrar
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to={{
                      pathname: `/${RoutesBase.login}`,
                      state: {
                        from: location,
                      },
                    }}
                    onClick={() => cleanHome()}
                  >
                    Cadastre-se
                  </Link>
                </li>
              </>
            )}
          </>
        </ul>
        <Link className="navbar-brand" to="/" onClick={() => cleanHome()}>
          <LogoVoala
            width="50px"
            height="auto"
            viewBox="45 0 135 70"
            fill="#FF5A00"
            className="link"
            style={{marginInline: '0.5rem'}}
          />
        </Link>
        <Link className="navbar-brand open-menu" to="/" onClick={() => cleanHome()}>
          <LogoVoala
            width="50px"
            height="auto"
            viewBox="45 0 135 70"
            fill="#FFFFFF"
            className="link"
            style={{marginInline: '0.5rem'}}
          />
        </Link>
        {isLogged ? (
          <li className="nav-item loginIcon">
            <Link className="nav-link new-link" to={`/${RoutesBase.myTravels.list}`}>
              <p>Bem vindo,</p>
              <span>{primeiroNome && primeiroNome.split(' ')[0]}</span>
            </Link>
          </li>
        ) : (
          <Link
            className="nav-link loginIcon"
            to={{
              pathname: `/${RoutesBase.login}/acesso`,
              state: {
                from: location,
              },
            }}
            onClick={() => cleanHome()}
          >
            <span>Acessar</span>
          </Link>
        )}
        <a
          href="#nav"
          className="nav-toggle"
          role="button"
          aria-expanded="false"
          aria-controls="menu"
          aria-label="main navigation"
          ref={ref => refMenuToggle(ref)}
          onClick={handleMenuToggle}
        >
          <svg
            className="menuicon"
            xmlns="http://www.w3.org/2000/svg"
            width="50"
            height="50"
            viewBox="0 0 50 50"
          >
            <title>Toggle Menu</title>
            <g>
              <line className="menuicon__bar" x1="13" y1="16.5" x2="37" y2="16.5" />
              <line className="menuicon__bar" x1="13" y1="24.5" x2="37" y2="24.5" />
              <line className="menuicon__bar" x1="13" y1="24.5" x2="37" y2="24.5" />
              <line className="menuicon__bar" x1="13" y1="32.5" x2="37" y2="32.5" />
              <circle className="menuicon__circle" r="23" cx="25" cy="25" />
            </g>
          </svg>
        </a>

        <div className="splash" />
      </>
    );
  }
}

export default withContext(withRouter(HeaderMenuMobile));
